import { Component } from '@angular/core';
import { LoaderService } from '../services/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent {

  loading = true;

  constructor(public loaderService: LoaderService) {
    this.loaderService.showSpinner.subscribe(this.showSpinner.bind(this));
  }

  showSpinner = (state: boolean): void => {
    this.loading = state;
  };
}